import { render, staticRenderFns } from "./PoolTeamCommentNotificationItem.vue?vue&type=template&id=8a56e458&scoped=true&"
import script from "./PoolTeamCommentNotificationItem.vue?vue&type=script&lang=ts&"
export * from "./PoolTeamCommentNotificationItem.vue?vue&type=script&lang=ts&"
import style0 from "./PoolTeamCommentNotificationItem.vue?vue&type=style&index=0&id=8a56e458&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a56e458",
  null
  
)

/* custom blocks */
import block0 from "./PoolTeamCommentNotificationItem.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports